module.exports = __webpack_public_path__ + "static/img/nfhs.0d3c8056.png";